<template>
    <b-container class="p-0">
        <b-row class="my-1" v-for="([prop , value], index) in Parameter.getProperties()" :key="prop + index">
                <!-- @Todo : Translate -->
                <b-col cols="3" class="m-auto">{{ prop }}</b-col>
                <b-col>
                    <b-form-select v-if="prop === 'Data'" :options="enumComboBoxData" v-model="Parameter[prop]" />
                    <b-form-select v-else-if="prop === 'Value'" :options="enumComboBoxValue" v-model="Parameter[prop]" />
                    <b-form-input v-else-if="typeof value === 'string'" v-model="Parameter[prop]" />
                </b-col>
            </b-row>
    </b-container>
</template>

<script lang="ts">

    import { Prop, Vue} from 'vue-property-decorator';
    import Component from 'vue-class-component';
    import VueI18n from 'vue-i18n' // translation support
    import locales from "../locales/ParametersItems.json";
    import ComboBoxField from '../Class/ComboBoxField';
    import { EnumComboBoxData } from '../Enums/EnumComboBoxData';
    import { EnumComboBoxValue } from '../Enums/EnumComboBoxValue';

    Vue.use(VueI18n);

    @Component({
        i18n: { messages: locales }
    })
	export default class ComboBoxModal extends Vue{
        /** Variant de couleur à appliquer sur le composant */
        @Prop({default: () => "secondary"})
		public Variant!: string;

        @Prop()
        public Parameter!: ComboBoxField;
        
        private enumComboBoxData: {value: string | EnumComboBoxData, text: string}[] = Object.entries(EnumComboBoxData).filter(([key, value]) => typeof value === 'number').map(([key, value]) => ({value: value, text: key}));
        private enumComboBoxValue: {value: string | EnumComboBoxValue, text: string}[] = Object.entries(EnumComboBoxValue).filter(([key, value]) => typeof value === 'number').map(([key, value]) => ({value: value, text: key}));
    }

</script>

<style scoped>
    :deep(input[type=checkbox]:checked) {
        /** Change la couleur de la checkbox */
        accent-color: var(--Variant) !important;
    }

    :deep(input[type=radio]:checked) {
        /** Change la couleur du bouton radio */
        accent-color: var(--Variant) !important;
    }

    /** Pour que la page active prenne en compte la couleur de Variant */
    :deep(.page-item.active .page-link) {
        background-color: var(--Variant) !important;
    }

    :deep(.page-link:hover) {
        background-color: var(--VariantLight) !important;
    }
</style>